"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedInTrack = exports.lintrk = void 0;
const lintrk = (action, options) => {
    window === null || window === void 0 ? void 0 : window.lintrk(action, options);
};
exports.lintrk = lintrk;
const linkedInTrack = (conversionId) => {
    (0, exports.lintrk)('track', { conversion_id: conversionId });
};
exports.linkedInTrack = linkedInTrack;
